import {
  Button,
  Group,
  Modal,
  Search,
} from "@veneer/core";
import { useEffect, useState } from "react";
import { POST_CALL_IS_SERVICE } from "../../../services";
import { apiPost } from "../../../services/service";
import "./modal.css";
import { ModalProps } from "../../../services/typedefine";
import { useNavigate } from "react-router-dom";
import CustomTable from "../../../components/shared-components/custom-table/custom-table";
import { useTranslation } from "react-i18next";

const Modall: React.FC<ModalProps> = ({
  modalState,
  handlepopupModal,
  value,
}) => {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("null");
  const [nameValue, setNameValue] = useState("");
  const [tableData, setTableData] = useState(data);
  const handleNameFilter = (value: any) => setNameValue(value);
  const [selectedRow, setSelectedRow] = useState<any | null>(null);
  const [noRecord, setNoRecord] = useState<boolean>(false);
  const navigate = useNavigate();
  const {t} = useTranslation();
  const columns = [
    {
      id: "AssetName",
      label: t('HPI.MainHomePage.assetsListModel.title',{defaultValue:'Asset'}),
      filter: (
        <Search
          label="Search"
          placeholder=""
          id="table-filter-Name"
          value={nameValue}
          onClear={() => setNameValue("")}
          onChange={handleNameFilter}
        />
      ),
    },
    {
      id: "AssertSerialNumber",
      label: t('AssetHeader\\SerialNumber',{defaultValue:'Serial number'}),
      filter: (
        <Search
          label="Search"
          placeholder=""
          id="table-filter-Name"
          value={nameValue}
          onClear={() => setNameValue("")}
          onChange={handleNameFilter}
        />
      ),
    },
    {
      id: "ProductId",
      label: t('AssetHeader\\ProductNumber',{defaultValue:'Product number'}),
      filter: (
        <Search
          label="Search"
          placeholder=""
          id="table-filter-Name"
          value={nameValue}
          onClear={() => setNameValue("")}
          onChange={handleNameFilter}
        />
      ),
    },
    {
      id: "ProductLineCode",
      label: t('AssetHeader\\ProductLine',{defaultValue:'Product Line'}),
      filter: (
        <Search
          label="Search"
          placeholder=""
          id="table-filter-Name"  
          value={nameValue}
          onClear={() => setNameValue("")}
          onChange={handleNameFilter}
        />
      ),
    },
  ];
  // const handleRowSelected = (data: any, e: any) => {
  //   const parentDiv = e.target.closest("tr");
  //   const table = e.target.closest("table");
  //   if (table) {
  //     const rows = table.querySelectorAll("tr");
  //     for (let row of rows) {
  //       row.classList.remove("selectedRow");
  //     }
  //   }
  //   if (parentDiv) {
  //     parentDiv.classList.add("selectedRow");
  //   }
  //   setSelectedRow(data);
  // };


  const handleOkClick = (): void => {

    if (selectedRow) {
      const uri = `ainfo=${selectedRow.AssertSerialNumber}&pno=${selectedRow.ProductId}`;
      {
        navigate(`/case-match?${uri}`);
      }
    }
  };

  useEffect(() => {
    if (!value) return;

    const fetchData = async () => {
      setLoading(true);
      setError("null");
      try {
        // let payload: any = {};
        // let response: any;
        const payload =
          value.type === "Serial Number"
            ? {
              serviceurl: `getentitlementbyserialnumber/${value.serialNumber}/us`,
              
              
            }
            : {
              serviceurl: `getassetbycontractid/${value.accountInfo}`,
              
              
            };

        let response =
          value.type === "Serial Number"
            ? await apiPost(POST_CALL_IS_SERVICE, payload)
            : await apiPost(POST_CALL_IS_SERVICE, payload);
        if (response.data.ISResponse === "") {
          setNoRecord(true);
        } else {
          setNoRecord(false);
        }

        if (value.type === "Serial Number" && response) {
          const assets = JSON.parse(response.data.ISResponse);
          const formattedData = JSON.parse(response.data.ISResponse).Assets.map(
            (item: any) => ({
              AssetName: item.AssetName,
              AssertSerialNumber: item.AssertSerialNumber,
              ProductId: item.Product?.ProductId,
              ProductLineCode: item.Product?.ProductLineCode,
            })
          );
          if (response.data.ISResponse === "") {
            setNoRecord(true);
          }
          setData(formattedData);
          setFilteredData(formattedData);
        } else {
          const assets = JSON.parse(response.data.ISResponse);
          const formattedData = assets.map((item: any) => ({
            AssetName: item.AssetName,
            AssertSerialNumber: item.AssertSerialNumber,
            ProductId: item.Product?.ProductId,
            ProductLineCode: item.Product?.ProductLineCode,
          }));

          setData(formattedData);
          setFilteredData(formattedData);
        }

        // if (props.value) {
        //     payload = { serviceurl: `getentitlementbyserialnumber/${props.value}/us`,  datalang: "en-US" };
        //     response = await apiPost(POST_CALL_IS_SERVICE, payload);
        // } else if (props.value2) {
        //     payload =
        //     response = await apiPost(POST_CALL_IS_SERVICE, payload);
        // }

        // if (response) {
        //     const assets = JSON.parse(response.data.ISResponse)
        //     const formattedData = assets.map((item: any) => ({
        //         AssetName: clickOndata(item, item.AssetName),
        //         AssertSerialNumber: clickOndata(item, item.AssertSerialNumber),
        //         ProductId: clickOndata(item, item.Product?.ProductId),
        //         ProductLineCode: clickOndata(item, item.Product?.ProductLineCode),
        //     }));
        //     setData(formattedData)
        //     setFilteredData(formattedData)

        // } else {
        //     throw new Error("No Data Found")
        // }
      } catch (err: any) {
        setError(err.messages || "Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };
    if (value) {
      fetchData();
    }
  }, [value]);

  useEffect(() => {
    if (!modalState) {
      setData([]);
      setFilteredData([]);
      setNoRecord(false);
    }
  }, [modalState]);


  const handleRowSelect = (data: any) => {
    setSelectedRow(data);
  };


  return (
    <div
      style={{ position: "relative" }}
      className="select-assets-popup-container"
    >
      <Modal
        align="start"
        closeButton
        className="select-assets-popup"
        show={modalState}
        onClose={() => {
          handlepopupModal();
          setOpen(modalState);
        }}
        footer={
          <Group className="">
            <Button onClick={handleOkClick} disabled={!selectedRow}>
              {t('HPI.Ok',{defaultValue:'Ok'})}
            </Button>
            <Button
              appearance="secondary"
              onClick={() => {
                handlepopupModal();
                setOpen(false);
              }}
            >
              {t('HPI.MainHomePage.assetsListModelfooter.close',{defaultValue:'Close'})}
            </Button>
          </Group>
        }
      >
        <div className="container">
          <div className="mb-2">
            {/* {" "} */}
            <h5>{t('HPI.MainHomePage.js.SelectAsset',{defaultValue:'Select Asset'})}</h5>
          </div>
          {noRecord ? (
            <p>{t('HPI.MainHomePage.js.NoRecord',{defaultValue:'No Records'})}</p>
          ) : (
            <CustomTable columns={columns} data={filteredData} onRowSelect={handleRowSelect} />
          )}

        </div>
      </Modal>
    </div>
  );
};
export default Modall;
